(function () {
    /* Source copied from https://github.com/danicomas/angular-jquery-maskedinput since not published on NPM */

    // Used in datePicker directives,
    // this cannot be replaced by ui-mask since the masked input does not have an ng-model binding
    // Does NOT remove the "static mask" from the model.

    "use strict";

    angular.module("app").directive("mask", MaskDirectiveFactory);

    function MaskDirectiveFactory() {
        return {
            restrict: "A",
            link: function (_scope, elem, attr) {

                if (attr.mask)
                    elem.mask(attr.mask, { placeholder: attr.maskPlaceholder });
            }
        };
    }
})();

